import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }

function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }

const toggleFacetInFacetsArray = (facets, facet) => {
  if (facets.includes(facet)) {
    return facets.filter(e => e !== facet);
  }

  return facets.concat(facet);
};

const toggleFacetInFilterBy = (filterBy, filter, facet) => {
  const {
    [filter]: filteredBy = []
  } = filterBy,
        rest = _objectWithoutProperties(filterBy, [filter].map(_toPropertyKey));

  const skeleton = toggleFacetInFacetsArray(filteredBy, facet);
  return _objectSpread({}, rest, skeleton.length && {
    [filter]: skeleton
  });
};

const addUniqFacetInFilterBy = (filterBy, filter, facet) => {
  const currentFilterBy = filterBy;
  const skeleton = {};

  if (currentFilterBy[filter] && currentFilterBy[filter][0] === facet) {
    skeleton[filter] = [];
  } else {
    skeleton[filter] = [facet];
  }

  return Object.assign(currentFilterBy, skeleton);
};

export { toggleFacetInFacetsArray, toggleFacetInFilterBy, addUniqFacetInFilterBy };